const iconActionable = {
  size: {
    '2xs': 'h-4 w-4',
    xs: 'h-4 w-4',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-5 w-5',
    xl: 'h-5 w-5',
  },
}

const sizeActionable = {
  '2xs': 'text-xs leading-4',
  xs: 'text-xs leading-4',
  sm: 'text-sm leading-4',
  md: 'text-sm leading-5',
  lg: 'text-base leading-6',
  xl: 'text-base leading-6',
}

const sizeInput = {
  '2xs': 'text-xs leading-4 h-7',
  xs: 'text-xs leading-4 h-7',
  sm: 'text-sm leading-4 h-8',
  md: 'text-sm leading-5 h-9',
  lg: 'text-base leading-6 h-10',
  xl: 'text-base leading-6 h-12',
}

const gapActionable = {
  '2xs': 'gap-x-1',
  xs: 'gap-x-2',
  sm: 'gap-x-2',
  md: 'gap-x-2',
  lg: 'gap-x-3',
  xl: 'gap-x-3',
}

const paddingActionable = {
  '2xs': 'px-2 py-1 h-7',
  xs: 'px-2.5 py-0 h-7',
  sm: 'px-3 py-0 h-8',
  md: 'px-4 py-0 h-9',
  lg: 'px-4 py-0 h-10',
  xl: 'px-6 py-0 h-12',
}

const configNuxtUi = {
  primary: 'escapadaPrimary',
  gray: 'escapadaGray',
  notifications: {
    position: 'top-0 bottom-auto',
  },
  button: {
    default: {
      loadingIcon: 'i-gg-spinner',
    },
    base: 'focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-opacity-50 transition ease-in-out duration-300 disabled:opacity-50',
    font: 'font-bold',

    color: {
      gray: {
        solid:
          'shadow-sm ring-1 text-gray-700 bg-gray-50 hover:bg-gray-100 focus-visible:outline-0 focus-visible:border-primary-500 focus-visible:ring-primary-400',
        link: 'gap-x-2',
        'link-underline':
          'underline dark:text-white text-gray-500 hover:underline hover:text-gray-900 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 gap-x-2',
      },
      white: {
        ghost:
          'text-gray-900 hover:bg-white hover:bg-gray-100 focus-visible:outline-0 focus-visible:ring-3 focus-visible:border-blue-300 focus-visible:ring-blue-400',
      },
      primary: {
        solid:
          'shadow-sm text-gray-900 bg-primary-400 hover:bg-primary-300 focus-visible:outline-0 focus-visible:border-primary-500 focus-visible:ring-primary-400',

        link: 'text-primary-600 hover:text-primary-500 underline-offset-4 hover:underline focus-visible:outline-0 gap-x-2',
      },
      red: {
        solid:
          'shadow-sm text-white bg-red-600 hover:bg-red-500 focus-visible:outline-0 focus-visible:border-red-500 focus-visible:ring-red-400',
        'link-underline':
          'underline text-red-700 dark:text-white  underline-offset-4 hover:underline hover:text-red-500 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-red-500 dark:focus-visible:ring-red-400 gap-x-2',
      },
      black: {
        link: 'text-gray-900 dark:text-white underline-offset-4 hover:underline hover:text-gray-500 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 gap-x-2',
        'link-underline':
          'underline text-gray-900 dark:text-white  underline-offset-4 hover:underline hover:text-gray-500 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 gap-x-2',
      },
    },
    variant: {
      concrete:
        'shadow-sm text-white bg-{color}-900 hover:bg-{color}-800 focus-visible:outline-0 focus-visible:border-{color}-500 focus-visible:ring-{color}-400',
      soft: 'text-{color}-700',
      'link-underline':
        'underline text-{color}-600 hover:underline hover:text-{color}-500 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400 gap-x-2',
    },
    icon: iconActionable,
    size: sizeActionable,
    gap: gapActionable,
    padding: paddingActionable,

    square: {
      '2xs': 'p-1 w-7',
      xs: 'p-1.5 w-7',
      sm: 'p-2 w-8',
      md: 'p-2 w-9',
      lg: 'p-2.5 w-10',
      xl: 'p-3.5 w-12',
    },
  },

  formGroup: {
    label: {
      base: 'text-gray-700 truncate block text-sm font-bold',
    },
  },

  input: {
    icon: iconActionable,
    size: sizeInput,
    gap: gapActionable,
    base: 'relative block w-full disabled:cursor-not-allowed disabled:opacity-75 disabled:bg-gray-100 focus:outline-none border-0 ',
  },

  select: {
    placeholder: 'text-gray-700',

    icon: iconActionable,
    size: sizeInput,
    gap: gapActionable,
  },
  modal: {
    overlay: {
      background: 'bg-gray-400/75',
    },
  },

  badge: {
    variant: {
      soft: 'bg-{color}-100 text-{color}-800 font-bold rounded-full',
    },

    default: {
      size: 'sm',
      variant: 'soft',
      color: 'primary',
    },
  },
  card: {
    body: {
      padding: 'p-3 sm:p-5',
    },
    header: {
      padding: 'p-3 sm:p-5',
    },
    footer: {
      padding: 'p-3 sm:p-5',
    },
  },
}

export default configNuxtUi
